import React from 'react';
import { Droplet, Cookie, Square } from 'lucide-react';
import { StarterTexture } from '../../types/baking';

interface TextureSelectorProps {
  value: StarterTexture;
  onChange: (texture: StarterTexture) => void;
}

export function TextureSelector({ value, onChange }: TextureSelectorProps) {
  const textures = [
    {
      id: 'liquid',
      label: 'Liquid',
      description: '100% hydration',
      icon: Droplet,
      color: 'text-blue-300'
    },
    {
      id: 'doughy',
      label: 'Doughy',
      description: '65-80% hydration',
      icon: Cookie,
      color: 'text-amber-300'
    },
    {
      id: 'hard',
      label: 'Stiff',
      description: '50-65% hydration',
      icon: Square,
      color: 'text-white'
    }
  ];

  return (
    <div className="grid grid-cols-3 gap-3">
      {textures.map((texture) => {
        const Icon = texture.icon;
        const isSelected = value === texture.id;
        
        return (
          <label
            key={texture.id}
            className={`relative flex flex-col items-center p-4 border rounded-xl cursor-pointer transition-all duration-200 ${
              isSelected
                ? 'border-amber-400/50 bg-gradient-to-b from-amber-400/20 to-amber-500/10'
                : 'border-white/10 bg-white/5 hover:bg-white/10'
            }`}
          >
            <input
              type="radio"
              name="texture"
              value={texture.id}
              checked={isSelected}
              onChange={() => onChange(texture.id as StarterTexture)}
              className="sr-only"
            />
            
            <Icon className={`w-8 h-8 mb-2 ${texture.color}`} />
            
            <div className="text-center">
              <span className="block font-medium text-sm text-white">
                {texture.label}
              </span>
              <span className="block text-xs text-white/70 mt-1">
                {texture.description}
              </span>
            </div>

            {isSelected && (
              <div className="absolute -top-1 -right-1 w-4 h-4 bg-amber-400 rounded-full border-2 border-black/20" />
            )}
          </label>
        );
      })}
    </div>
  );
}